// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"e4a00700","793":"766d725c","988":"9c70ec51"}[chunkId] + ".chunk.css";
};